import { Tag, TagGroup, Tooltip, TooltipTrigger } from '@backstage/ui';
import { getResourceTypeColor } from '@internal/backstage-plugin-catalog-devops-common';

interface ResourceTypeChipProps {
  type: string;
  /** Shown in the tooltip, so the service stays discoverable without its
   * own table column (the mockup replaces the Service column with this). */
  service?: string;
}

/**
 * Renders a resource type as a chip. The background color is generated
 * deterministically from the type name, matching the color served by the
 * cloud-resources menu backend API.
 */
export function ResourceTypeChip({ type, service }: ResourceTypeChipProps) {
  const color = getResourceTypeColor(type);

  const tag = <Tag style={{ backgroundColor: color }}>{type}</Tag>;

  return (
    <TagGroup aria-label="Resource type">
      {service ? (
        <TooltipTrigger>
          {tag}
          <Tooltip>Service: {service}</Tooltip>
        </TooltipTrigger>
      ) : (
        tag
      )}
    </TagGroup>
  );
}

/**
 * Overrides the `type` column of a data grid so the type is rendered as a
 * colored chip instead of plain text.
 */
